import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import AllAdmin from './AllAdmin'

class ParselAllAdmin extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={AllAdmin} {...props}/>
   )
 }
}



export default ParselAllAdmin;
